import { arrayToMap } from 'nucleus-widgets/utils/arrayToMap';
/*
 * Transforms the snapshot to make it easier to work with in the application.
 */
export default function transformAccountSnapshot(accountSnapshot) {
    return Object.assign(Object.assign({}, accountSnapshot), { contactGroups: accountSnapshot.contactGroups &&
            [...accountSnapshot.contactGroups].sort((cg0, cg1) => {
                if (!(cg0 === null || cg0 === void 0 ? void 0 : cg0.name)) {
                    return (cg1 === null || cg1 === void 0 ? void 0 : cg1.name) ? 1 : 0;
                }
                return cg0.name.localeCompare(cg1.name);
            }), contactCustomFields: arrayToMap(accountSnapshot.contactCustomFields, customField => customField.question.id) });
}
